(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const filterButtons = document.querySelectorAll(".filter-btn");
  const posts = document.querySelectorAll(".blog-post-item");
  const underline = document.querySelector(".filter-underline");

  function updateUnderline(el) {
    underline.style.width = `${el.offsetWidth}px`;
    underline.style.left = `${el.offsetLeft}px`;
  }

  if (filterButtons.length > 0 && posts.length > 0 && underline) {
    // initialize underline
    const activeBtn = document.querySelector(".filter-btn.active");
    if (activeBtn) updateUnderline(activeBtn);

    filterButtons.forEach(btn => {
      btn.addEventListener("click", () => {
        // Remove active class
        filterButtons.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");

        // Move underline
        updateUnderline(btn);

        // Filter posts
        const filter = btn.getAttribute("data-filter").trim();
        posts.forEach(post => {
          const tags = post.dataset.tags
            ? post.dataset.tags.split(",").map(t => t.trim())
            : [];

          if (filter === "all" || tags.includes(filter)) {
            post.style.display = "block";
          } else {
            post.style.display = "none";
          }
        });
      });
    });

    // update underline on window resize
    window.addEventListener("resize", () => {
      const activeBtn = document.querySelector(".filter-btn.active");
      if (activeBtn) updateUnderline(activeBtn);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonialv2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper !== "undefined") {
    var swiperEl = document.querySelector(".testimonial-swiper");
    var slidesCount = swiperEl.querySelectorAll(".swiper-slide").length;

    // Hide arrows if only 1 slide
    var arrowWrap = swiperEl.querySelector(".arw-wrap");
    if (slidesCount <= 1 && arrowWrap) {
      arrowWrap.style.display = "none";
    }

    new Swiper(".testimonial-swiper", {
      loop: slidesCount > 1, // Enable loop only if more than 1 slide
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: ".custom-next",
        prevEl: ".custom-prev",
      },
      breakpoints: {
        1024: { slidesPerView: 1 },
        768: { slidesPerView: 1 },
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
